import { Grid } from "@mui/material";
import { makeStyles } from '@mui/styles';
import Typography from "@mui/material/Typography";

const useStyles = makeStyles((theme) => ({
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(1),
    position: "fixed",
    bottom: 0,
    width: "100%",
  },
  donateBtnContainer: {
    lineHeight: 0,
  },
}));

const Copyright = () => (
  <Typography variant="body2" color="textSecondary" align="center">
    {`Copyright © Taste notes ${new Date().getFullYear()}.`}
  </Typography>
);

const DonateBtn = () => (
  <Typography variant="body2" align="center" style={{ lineHeight: 0 }}>
    <a href="https://buycoffee.to/iskrzycki" target="_blank" rel="noreferrer">
      <img
        src="https://buycoffee.to/btn/buycoffeeto-btn-primary-outline.svg"
        style={{ width: "130px" }}
        alt="Postaw mi kawę na buycoffee.to"
      />
    </a>
  </Typography>
);

const Footer = () => {
  const classes = useStyles();

  return (
    <footer className={classes.footer}>
      <Grid container spacing={0} justifyContent="center" alignItems="center">
        <Grid item sm={4}></Grid>
        <Grid item xs={6} sm={4} className={classes.donateBtnContainer}>
          <DonateBtn />
        </Grid>
        <Grid item xs={6} sm={4}>
          <Copyright />
        </Grid>
      </Grid>
    </footer>
  );
};

export default Footer;
